import { combineReducers } from "@reduxjs/toolkit";
import { filtersDataGOS } from "../store/filterData/filterData";
import { addForms } from "../store/addForms/addForms";
import { fileUploadsReducer } from "../store/fileUploads/reducer";
import { settings } from "src/pages/DashboardPage/gos/store/settings/settings";
import { help } from "src/pages/DashboardPage/gos/store/help/help";

export const rootGos = combineReducers({
  filtersData: filtersDataGOS,
  settings: settings.reducer,
  help: help.reducer,
  addForms: addForms,
  fileUploads: fileUploadsReducer,
});
